import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewModeEnum, AlertDialogTypeEnum } from '../../../../_enums/_index';
import { DealServiceItemModel } from '../../../../_models/_index';

@Component({
  selector: 'app-deal-service-item-dialog',
  templateUrl: './deal-service-item-dialog.component.html',
  styleUrls: ['./deal-service-item-dialog.component.css']
})
export class DealServiceItemDialogComponent implements OnInit {
    dialogHeader: string;
    viewMode: ViewModeEnum;
    dealServiceItem: DealServiceItemModel = new DealServiceItemModel();

    constructor(private dialog: MatDialog,
        public dialogRef: MatDialogRef<DealServiceItemDialogComponent>) { }

  ngOnInit() {
  }

  getSaveText() {
      switch (this.viewMode) {
          case ViewModeEnum.Add:
              return "הוסף";
          case ViewModeEnum.Edit:
              return "עדכן";
      }
  }

  save() {
      if (this.viewMode == ViewModeEnum.Add) {
          this.addDealService();
      }
      else {
          this.editDealService();
      }
  }

  private addDealService() {
     
      this.dialogRef.close(this.dealServiceItem);
          
      
  }

  private editDealService() {
      this.dialogRef.close(this.dealServiceItem);
  }

  private isEditMode() {
      return this.viewMode == ViewModeEnum.Edit;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-package/deal-service-item-dialog/deal-service-item-dialog.component.ts